interface Book { isbn: string, title: string, author: string }
export interface SearchOn { label: string, value: Book }

export const emptyBook = { isbn: "", title: "", author: "" }